import { render, staticRenderFns } from "./LeftNavUpper.vue?vue&type=template&id=964572aa&scoped=true"
import script from "./LeftNavUpper.vue?vue&type=script&lang=js"
export * from "./LeftNavUpper.vue?vue&type=script&lang=js"
import style0 from "./LeftNavUpper.vue?vue&type=style&index=0&id=964572aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964572aa",
  null
  
)

export default component.exports